import React, { Component } from 'react';

class Buscador extends Component {
    constructor(props) {
        super(props);

        this.limpiarBusqueda = this.limpiarBusqueda.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.buscarModelos = this.buscarModelos.bind(this);
    }

    buscarModelos(event) {
        let valorInput = event.target.value;

        this.props.buscarModelos(valorInput);
    }

    limpiarBusqueda() {
        this.props.buscarModelos("");
    }

    onKeyPress(event) {
        let regExp = /[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ \s]/ig;

        if (!regExp.test(event.key)) {
            event.preventDefault();
        }
    }

    render() {
        const { inputBuscador } = this.props;

        return (
            <div className="row ModelosContables--overflowHidden">
                <div className="col-md-12 seccionSuperior__buscador ModelosContables--floatLeft">
                    <div className="AsientosContables--floatLeft seccionSuperior__iconoLupa"></div>

                    <div className="AsientosContables--floatLeft ModelosContables__contenedorBuscadorInput">
                        <input id="buscarModeloContable"
                            name="buscarModeloContable"
                            value={inputBuscador}
                            className="textbox-rectangular form-control default-input top-separator-xxxs bottom-separator-xxs seccionSuperior__inputBuscador"
                            onChange={this.buscarModelos}
                            onKeyDown={null}
                            onFocus={null}
                            onKeyPress={this.onKeyPress}
                            placeholder="Buscar por código, nombre, marca o tipo de movimiento" />
                    </div>
                </div>

                {inputBuscador?.length > 0 ?
                    <div className="seccionSuperior__botonBuscador ModelosContables--floatLeft ModelosContables--positionAbsolute">
                        <button type="button" className="btn-tag seccionSuperior__botonBorrarBusqueda ModelosContables__botonBorrarBuscador"
                            onClick={this.limpiarBusqueda}>
                            <span className="ti-close span-closable" />
                        </button>
                    </div>
                :
                    null
                }
            </div>
        );
    }
};

export default Buscador